import { FilterTagBar } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useCarrierContractListFilter } from './useCarrierContractListFilter';

export function Tags() {
  const { carriers, setCarriers } = useCarrierContractListFilter();
  const { t } = useTranslation();

  return (
    <FilterTagBar.Root>
      <FilterTagBar.Button
        onClick={() => setCarriers([])}
        label={t('common.carrierProduct')}
        value={carriers}
        name="carriers"
      />
    </FilterTagBar.Root>
  );
}
